
































import { Dialog, Scrollbar } from 'element-ui';
import { reviewPost } from '@/api/moments';
export default {
  name: 'ReviewDialog',
  components: {
    ElDialog: Dialog,
    ElScrollbar: Scrollbar
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    refId: {
      type: Number,
      default: null
    },
    source: {
      type: String,
      default: 'dynamic'
    },
    content: {
      type: String,
      default: null
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    dialogCannel() {
      this.model = false
      this.$emit('close')
    },
    /**
     * @description 审核内容
     * @param { string } reviewStatus 审核状态
     */
    async handleReview(reviewStatus) {
      const data = await this.$axios(reviewPost({
        reviewStatus,
        source: this.source,
        refIds: [this.refId]
      }))
      if (data.statusCode === 200 && reviewStatus === 'passed') {
        this.$emit('success')
      } else {
        if (reviewStatus === 'notPassed') {
          this.$emit('error', '内容审核不通过')
        } else {
          this.$emit('error', data.message)
        }
      }
      this.dialogCannel()
    }
  }
}
